// extracted by mini-css-extract-plugin
module.exports = {"quickNav":"quickStyles-module--quickNav--I4lT4"};